import { useState, useCallback } from 'react'
import { observer } from 'mobx-react'
import { Progress, Space } from 'antd'
import { ListSearch, EasyCustomTable, EasyImg } from 'src/components'
import { mainStore } from 'enasops/stores'
import { $api, $consts } from 'src/plugins'
import { extendRulesAndGroups, initFilter } from 'src/utils/common'
import 'enasops/styles/op/106/index.less'

const OP106 = () => {
  const [search, setSearch] = useState()

  const getList = (params: any) => {
    const { PageIndex, Limit, Rules, Groups } = params
    const payload = initFilter({ OrgId: mainStore.headers.OrgId, PageIndex, Limit })
    extendRulesAndGroups(payload, { Rules, Groups })
    return $api['op106/getServerStatusInfo'](
      payload,
      { fullData: true }
    )
  }

  const rowItem = useCallback((record: any) => {
    const online = record.OnlineStatus === $consts['DEVICE/STATUS_ONLINE']
    return (
      <div className='op106__table-item'>
        <EasyImg src={require('enasops/assets/op/106/server.png')} />
        <div className='item'>
          <p>服务器名称</p>
          <p>{record.ServerName}</p>
        </div>
        <div className='item'>
          <p>运行状态</p>
          <p className={online ? 'online' : 'offline'}>{online ? '正常' : '异常'}</p>
        </div>
        <div className='item'>
          <p>外网IP</p>
          <p>{record.IPAddress}</p>
        </div>
        <div className='item'>
          <p>内网IP</p>
          <p>{record.IPAddressIntranet}</p>
        </div>
        <div className='charts'>
          <Space size={60}>
            <Progress
              type='dashboard'
              percent={record.CpuUsage || 0}
              size={88}
              status={record.CpuUsage >= 80 ? 'exception' : 'normal'}
              format={p => <span>{p}%<br /><span className='charts-unit'>CPU</span></span>}
            />
            <div className='position-relative'>
              <Progress
                type='dashboard'
                percent={record.MemoryUsage || 0}
                size={88}
                status={record.MemoryUsage >= 80 ? 'exception' : 'normal'}
                format={p => <span>{p}%<br /><span className='charts-unit'>内存</span></span>}
              />
              <div className='charts-attach'>{record.MemoryTotal}</div>
            </div>
            <div className='position-relative'>
              <Progress
                type='dashboard'
                percent={record.DiskUsage || 0}
                size={88}
                status={record.DiskUsage >= 80 ? 'exception' : 'normal'}
                format={p => <span>{p}%<br /><span className='charts-unit'>磁盘</span></span>}
              />
              <div className='charts-attach'>{record.DiskSize}</div>
            </div>
          </Space>
        </div>
      </div>
    )
  }, [])

  return (
    <div className='op106'>
      <ListSearch preventAutoData formCode='OP106' onSearch={setSearch} />
      <div className='op106__table'>
        <EasyCustomTable
          extraPayload={search}
          remoteMethod={getList}
          rowField={{ itemCount: 1, gapVertical: 0 }}
          rowItem={rowItem}
        />
      </div>
    </div>
  )
}

export default observer(OP106)